import React, { FC, useState } from "react";
import {
  Button,
  Container,
  List,
  Search,
  Table,
  useFetch,
  useFilters,
  usePagination,
  Modal,
} from "@epcnetwork/core-ui-kit";

import { getOrganizations } from "api";
import { usePayload } from "hooks";
import { OrganizationModel } from "models";
import { QueryType } from "./organizations-list.types";
import { initialSearchFilters, entityName, TABLE_COLUMNS } from "./organizations-list.constants";
import OrganizationForm from "../form/organizations-form.page";
import TableRow from "./table-row/table-row";

import styles from "./organizations-list.module.css";

const OrganizationsListPage: FC = () => {
  const { searchValue, setSearch, queryString } = useFilters<QueryType>(initialSearchFilters);
  const [editId, setEditId] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const dependencies = [queryString];
  const apiResponse = useFetch(getOrganizations.setQueryParams(queryString), { dependencies });
  const pagination = usePagination(apiResponse.payload);
  const { payload, list, refresh, error, loading } = usePayload(apiResponse);

  const handleAdd = () => {
    setEditId(null);
    setIsModalOpen(true);
  };

  const handleEdit = (id: string) => {
    setEditId(id);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditId(null);
  };

  const handleItemChange = (values: OrganizationModel) => {
    const isExistElement = list.some((el) => el.id === values.id);
    const filteredList = list.filter((listElem) => listElem.id !== values.id);
    const newData: List<OrganizationModel> = {
      ...payload,
      data: [values, ...filteredList],
      total: isExistElement ? Number(payload.total) : Number(payload.total) + 1,
    };
    apiResponse.actions.setData(newData);
    setIsModalOpen(false);
  };

  return (
    <Container>
      <div className={styles.headerWrapper}>
        <div className={styles.searchHeaderWrapper}>
          <div className={styles.searchFormContainer}>
            <Search searchValue={searchValue} setSearch={setSearch} width="small" />
          </div>
        </div>
        <>
          <Button appearance="primary" onClick={handleAdd} className={styles.addBtn}>
            + Add Organization
          </Button>
          <Button appearance="primary" onClick={handleAdd} className={styles.addSmallScreen}>
            + Add
          </Button>
        </>
      </div>
      <Table
        columns={TABLE_COLUMNS}
        list={list}
        entityName={entityName}
        error={error?.message}
        loading={loading}
        refresh={refresh}
        pagination={pagination}
        isTabTable
        row={(item) => <TableRow key={item.id} item={item} handleEdit={handleEdit} />}
      />

      <Modal isOpen={isModalOpen} setClose={handleCloseModal} contentClassName={styles.modal}>
        <OrganizationForm
          handleCloseModal={handleCloseModal}
          handleItemChange={handleItemChange}
          id={editId}
        />
      </Modal>
    </Container>
  );
};

export default OrganizationsListPage;
